import { cva, type VariantProps } from 'class-variance-authority'

export { default as Button } from './Button.vue'

export const buttonVariants = cva(
  'inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md text-sm font-medium transition-colors focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:pointer-events-none disabled:bg-surface-disabled disabled:opacity-50 [&_svg]:pointer-events-none [&_svg]:size-4 [&_svg]:shrink-0 shadow-sm disabled:shadow-none',
  {
    variants: {
      variant: {
        default:
          'bg-primary text-silver hover:bg-primary hover:text-primary-foreground/80 disabled:text-content-primary',
        glass:
          'glass-morphism hover:bg-glass-hover text-silver hover:text-content-primary/20 backdrop-blur-xl hover:backdrop-blur-lg transition-all border-silver/20 border shadow',
        destructive:
          'bg-white text-red-500 hover:bg-red-300/20 border border-red-500/20 hover:text-red-600 shadow-none transition-colors duration-200',
        cta: 'bg-accent text-white hover:bg-accent-hover disabled:bg-accent/60 disabled:font-normal',
        outline:
          'border border-border bg-background hover:bg-surface-raised hover:text-accent-foreground hover:bg-silver/40',
        secondary: 'bg-surface-raised text-secondary-foreground hover:bg-silver/80 border border-border',
        ghost: 'hover:bg-surface-raised hover:text-accent-foreground shadow-none',
        link: 'text-content-primary underline-offset-4 hover:underline shadow-none',
        tertiary: 'border border-border bg-background hover:bg-surface-raised hover:text-accent-foreground',
        selection: 'bg-accent/10 hover:bg-accent/20 text-accent border-accent/60 hover:border-accent border'
      },
      size: {
        default: 'h-9 px-4 py-2',
        tiny: 'h-5 rounded-full px-2 text-tiny',
        'tiny-squared': 'h-5 rounded-sm px-2 text-tiny',
        xs: 'h-7 rounded-sm px-2 text-xs',
        sm: 'h-8 px-3 text-xs+',
        lg: 'h-10 rounded-lg px-8',
        'icon-sm': 'h-8 text-xs+ px-2',
        icon: 'h-9 w-9 rounded-md'
      }
    },
    defaultVariants: {
      variant: 'default',
      size: 'default'
    }
  }
)

export type ButtonVariants = VariantProps<typeof buttonVariants>
